import { EncodingTriggeredHistoryDto, EncodingVersionDto } from "app/SharedApiClient";
import { LoadingState } from "types";

export interface ProjectEncodingVersionState {
  latestEncodingVersion?: EncodingVersionDto | null;
  encodingTriggeredHistory: EncodingTriggeredHistoryDto | null;
  encodingTriggeredHistoryLoading: LoadingState;
  encodingTriggeredErrorMessage?: string | null | undefined;
  loading: LoadingState;
  availableVersions: EncodingVersionDto[];
  encodingProgressStage?: string;
  encodingLastUpdateReceived?: string;
  availableVersionsLoading: LoadingState;
}

export const originProjectEncodingVersion: ProjectEncodingVersionState = {
  loading: LoadingState.idle,
  encodingTriggeredHistory: null,
  encodingTriggeredHistoryLoading: LoadingState.idle,
  availableVersions: [],
  availableVersionsLoading: LoadingState.idle,
};
